<template>
  <v-toolbar flat color="white">
    <v-toolbar-items>
      <v-icon>add</v-icon>
    </v-toolbar-items>
    <v-toolbar-title class="subtitle-1">{{ type | friendlyLabel }}</v-toolbar-title>
    <v-toolbar-title>
      <v-select v-if="isBool"
                v-model="value"
                :items="validationBoolItems"
                :clearable="toolbarEnabled"
                :readonly="!toolbarEnabled"
                :placeholder="$t('checklists.select-value')"
                @change="update"
                class="mt-6 ml-4"
      ></v-select>
      <v-text-field v-if="isText"
                    v-model="value"
                    :clearable="toolbarEnabled"
                    :readonly="!toolbarEnabled"
                    :placeholder="$t('checklists.enter-value')"
                    @input="update"
                    class="mt-6 ml-4"
      ></v-text-field>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn text icon color="error" :title="$t('remove')" @click="remove" v-if="toolbarEnabled">
      <v-icon>delete_forever</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: 'input-validation-editor',
  props: {
    item: Object,
    parent: String
  },
  data () {
    return {
      value: this.item.value,
      type: this.item.type
    }
  },
  computed: {
    validationBoolItems () {
      return [
        { text: this.$t('yes'), value: true },
        { text: this.$t('no'), value: false }
      ]
    },
    isBool () {
      return (/switch/).test(this.parent)
    },
    isText () {
      return (/number|string|file/).test(this.parent)
    },
    toolbarEnabled () {
      return this.$store.getters['checklist/isFilled'] === false
    }
  },
  methods: {
    remove () {
      this.$emit('remove', { type: this.type })
    },
    update (value) {
      this.$emit('update', {
        type: this.type,
        value: this.sanitizeValue(value)
      })
    },
    sanitizeValue (value) {
      if (value === null) {
        return null
      }
      switch (this.parent) {
        case 'switch':
          return Boolean(value)
        case 'file': // return number of files attached
        case 'number':
          return Number(value)
        case 'string':
          return String(value)
      }
    }
  },
  filters: {
    friendlyLabel (val) {
      return val.replace(/([A-Z])/g, ' $1').toLowerCase()
    }
  }
}
</script>
